export default __webpack_public_path__ + "static/media/round-action-check-circle.2a58867e.svg";